/* eslint-disable no-param-reassign */

/**
 * Adds the specified CSS class or classes to the specified element.
 * @param element An HTML element to be manipulated
 * @param value One or more space-separated classes to be added to the
 * class attribute of the specified element.
 */
export default function addClass(element) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var initialValue = element.className;
  element.className = String(value).split(/\s+/).reduce(function (previousValue, currentValue) {
    if (" ".concat(previousValue, " ").indexOf(" ".concat(currentValue, " ")) !== -1) {
      return previousValue;
    }

    return "".concat(previousValue, " ").concat(currentValue).trim();
  }, initialValue);
}
//# sourceMappingURL=addClass.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/fraud/~/@flowio/browser-helpers/dist/esm/addClass.js
// module id = 551
// module chunks = 0 1